const home = {
	data: {
		id: 'home',
		title: 'Welcome to the AmmoNyte Wiki!',
		introduction: 'So far, the only thing here is how to get your machine set up... More coming soon as features are added and the project grows! Below is an outline of what this page is planned to contain (for now).',
		sections: [
			{
				id: '01',
				title: 'Project Description',
				content: [
					'introduction to the goal of the project',
					'brief description of the different parts of the project and what problems they solve'
				]
			},
			{
				
				id: '02',title: 'Introduction to Aquariums',
				content: [
					'Basic equipment',
					'Aspects to consider ',
					'Common misconceptions ("fish grow to the size of the tank")'
				]
			},
			{
				id: '03',
				title: 'Common Problems',
				content: [
					'Survey results so far',
					'Algae, light cycle, beginner setup, water testing, "nanny" mode',
					'No centralized place for researching aquarium inhabitant requirements',
					`Getting started is overwhelming ("wtf is the nitrogen cycle?", "You're supposed to change the water?")`,
					'comparing parameters with other users or with past measurements',
					'checking compatibility with your tank or the tank you have in mind',
					'tracking changes in water quality',
					'expensive products currently on the market (timers, not actually automated)',
					'Inspiration to create this project (include pics from aftermath of shitty auto-feeder)'
				]
			},
			{
				id: '04',
				title: 'Solution',
				content: [
					'User stories',
					'Broken down by: feature or solution to problem?',
					'Automated aspects',
					'Centralized place for searching plants/animals',
					'View your profile and share with others (useful for posting to forums about a problem)',
					'R&D'
				]
			}
		]
	}
};
const tutorials = {
	data: {
		id: 'tutorials',
		title: 'TUTORIALS',
		introduction: 'This page is to document the tutorials used in this project so it can be replicated easier',
		toc: {
			title: 'Table of Contents',
			content: [
				'Overview',
				'Required Parts',
				'Basic Setup',
				'WiFi Setup',
				'SSH',
				'Web Site Configuration',
				'Temperature Sensor',
				'Video Stream',
				'Analog Servo Motor'
			]
		},
		sections: [
			{
				id: '10',
				title: 'Overview',
				content: [
					'The computer that this project runs on is a Raspberry Pi Zero.It uses a cheap Logitech Webcam to live stream video of the aquarium using Motion. The RPi is also connected to a 4 channel relay that powers 4 outlets individually. This page will cover the tutorials necessary to start with a collection of parts to finishing with a completed build with the project installed.',
				]
			},
			{
				id: '11',
				title: 'Required Parts',
				content: [
					'TODO'
				]
			},
			{
				id: '12',
				title: 'Basic Setup',
				content: [
					'TODO'
				]
			},
			{
				id: '13',
				title: 'WiFi Setup',
				content: [
					'TODO'
				]
			},
			{
				id: '14',
				title: 'SSH',
				content: [
					'TODO'
				]
			},
			{
				id: '15',
				title: 'Web Site Configuration',
				content: [
					'TODO'
				]
			},
			{
				id: '16',
				title: 'Temperature Sensor',
				content: [
					'TODO'
				]
			},
			{
				id: '17',
				title: 'Video Stream',
				content: [
					'TODO'
				]
			},
			{
				id: '18',
				title: 'Analog Servo Motor',
				content: [
					'TODO'
				]
			}
		]
	}
};
const setup = {
	data: {
		id: 'setup',
		title: 'SETUP',
		subtitle: 'Setting up AmmoNyte',
		introduction: 'In order to run everything in the Web folder, the LAMP stack must first be installed. LAMP stack stands for Linux, Apache, MySQL, and PHP.These three technologies used together create the server that the system runs on.This guide assumes that Linux is already installed on the machine being used to install the server.',
		sections: [
			{
				id: '20',
				title: 'Install LAMP Stack',
				content: 'This section of the README uses the documentation from Ubuntu to show the commands in the terminal needed to install the required components of the server.',
				code: ''
			},
			{
				id: '21',
				title: 'Install Apache2',
				content: 'To install Apache you must install the Metapackage apache2. This can be done by searching for and installing in the Software Centre, or by running the following command.',
				code: '$> sudo apt-get install apache2'
			},
			{
				id: '22',
				title: 'Install MySQL',
				content: 'To install MySQL you must install the Metapackage mysql-server. This can be done by searching for and installing in the Software Centre, or by running the following command.',
				code: '$> sudo apt-get install mysql-server'
			},
			{
				id: '23',
				title: 'Install PHP',
				content: 'To install PHP you must install the Metapackages php5 and libapache2-mod-php5. This can be done by searching for and installing in the Software Centre, or by running the following command.',
				code: '$> sudo apt-get install php5 libapache2-mod-php5'
			},
			{
				id: '24',
				title: 'SETUP SERVER',
				content: 'Now that the LAMP stack is installed (our sever), the server needs to be setup.',
				code: ''
			},
			{
				id: '25',
				title: 'Restart Server',
				content: `Your server should restart Apache automatically after the installation of both MySQL and PHP. If it doesn't, execute this command.`,
				code: '$> sudo /etc/init.d/apache2 restart'
			},
			{
				id: '26',
				title: 'Check Apache',
				content: 'Open a web browser and navigate to http://localhost/. You should see a message saying It works!',
				code: ''
			},
			{
				id: '27',
				title: 'Check PHP',
				content: 'You can check your PHP by executing any PHP file from within /var/www/. Alternatively you can execute the following command, which will make PHP run the code without the need for creating a file.',
				code: `$> php -r 'echo "\n\nYour PHP installation is working fine.\n\n\n";'`
			},
			{
				id: '28',
				title: 'INSTALL NodeJS',
				content: 'For seamless interaction between the Raspberry Pi and the clients, we must install nodejs to create a seamless connection between the two. I would like to thank Simon W. Jackson for providing an extremely simple tutorial on how to properly install this on the Raspberry Pi Zero (the one used for this project). His tutorial can be found here:',
				code: 'https://blog.miniarray.com/installing-node-js-on-a-raspberry-pi-zero-21a1522db2bb'
			},
			{
				id: '29',
				title: 'Download ARMv61 Version',
				content: 'This version is slightly older than the ARMv7 version but it works with the RPi Zero.',
				code: '$> cd ~; wget http://nodejs.org/dist/v4.2.4/node-v4.2.4-linux-armv6l.tar.gz'
			},
			{
				id: '210',
				title: 'Extract to Local Directory',
				content: `Extract the downloaded files to the Pi's local directory.`,
				code: `$> cd /usr/local; sudo tar xzvf ~/node-v4.2.4-linux-armv6l.tar.gz --strip=1`
			},
			{
				id: '211',
				title: `Remove Debian's NodeJS Package`,
				content: 'You may not have it installed but should still try removing them to prevent future problems.',
				code: `$> sudo apt-get remove --purge npm node nodejs`
			},
			{
				id: '212',
				title: 'Verify Installation',
				content: `Now check to make sure that the installation was successful by checking the version info with this command.`,
				code: `$> node -v`
			},
			{
				id: '213',
				title: 'Increase Install Speed (optional)',
				content: `The default installer for nodejs is slow. This command will upgrade the installer and increase install speeds which will make development easier. This command may seem like it isn't working initially, but give it a little time to work.`,
				code: `$> sudo npm install -g npm`
			},
		],
		update: {
			title: 'UPDATE',
			content: 'Seems like there are some troubles with this method when using npm to install modules. The solution used for this project can be found here: ',
			link: 'http://eddielee.me/running-node-js-on-a-raspberry-pi-zero/'
		}
	},
	
};
const style = {
	title: `STYLE`,
	introduction: ``,
	sections: []
}

const WikiStore = {
    data: {
			Home: home,
			Tutorials: tutorials,
			Setup: setup
		}
};
export default WikiStore;


// WEBPACK FOOTER //
// ./src/stores/WikiStore.js